import { Routes } from '@angular/router';

import { authGuard, guestGuard } from './core/guards/auth.guard';
import { DashboardPageComponent } from './features/dashboard/dashboard-page.component';
import { EntityPageComponent } from './features/entity/entity-page.component';
import { LoginPageComponent } from './features/login/login-page.component';
import { ReportsPageComponent } from './features/reports/reports-page.component';

export const routes: Routes = [
	{
		path: '',
		pathMatch: 'full',
		redirectTo: 'login'
	},
	{
		path: 'login',
		component: LoginPageComponent,
		canActivate: [guestGuard]
	},
	{
		path: 'dashboard',
		component: DashboardPageComponent,
		canActivate: [authGuard]
	},
	{
		path: 'records/:entity',
		component: EntityPageComponent,
		canActivate: [authGuard]
	},
	{
		path: 'reports',
		component: ReportsPageComponent,
		canActivate: [authGuard]
	},
	{
		path: '**',
		redirectTo: 'dashboard'
	}
];
